var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.354 0.854021L8.35402 7.85402C8.30758 7.90058 8.2524 7.93753 8.19165 7.96273C8.13091 7.98794 8.06579 8.00092 8.00002 8.00092C7.93425 8.00092 7.86913 7.98794 7.80839 7.96273C7.74764 7.93753 7.69247 7.90058 7.64602 7.85402L0.646021 0.854021C0.552135 0.760134 0.49939 0.632797 0.49939 0.500021C0.49939 0.367245 0.552135 0.239908 0.646021 0.146021C0.739908 0.0521343 0.867246 -0.000610349 1.00002 -0.000610352C1.1328 -0.000610354 1.26013 0.0521343 1.35402 0.146021L8.00002 6.79302L14.646 0.146021C14.7399 0.0521343 14.8672 -0.000610354 15 -0.000610352C15.1328 -0.000610349 15.2601 0.0521343 15.354 0.146021C15.4479 0.239908 15.5007 0.367245 15.5007 0.500021C15.5007 0.632797 15.4479 0.760134 15.354 0.854021Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.9c366396543eba9d835dd47cd7de1363.svg";
export { ForwardRef as ReactComponent };